import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles(() => ({
  root: {
    background: "#383E52",
    width: "100vw",
    height: "100vh",
    color: "white",
    position: "fixed",
    left: 0,
  },
}));

interface Props {
  children: React.ReactNode;
}

const EmptyLayout: React.FC<Props> = ({ children }: Props) => {
  const classes = useStyle();

  return <div className={classes.root}>{children}</div>;
};

export default EmptyLayout;
